<div *ngIf="filterOptionLoaded" id="pipeFilter">
  <div id="filter-header">

    <section *ngIf="filterModelGroupe">
      <h1>Modèles de filtre</h1>
      <div id="wrapper-model">
        <select class="q-main-select" (change)="changeFilterModel($event)">
          <option value="" [selected]="!currentFilterModel.Code_MOD">Sélectionner un modèle</option>
          <option *ngFor="let filterModel of filterModelList" [ngValue]="filterModel.Code_MOD" [selected]="currentFilterModel.Code_MOD == filterModel.Code_MOD">{{filterModel.Info_MOD}}</option>
        </select>

        <!--<button (click)="OpenModelSave(content)" class="q-btn q-main" title="Gerer les modèle"><i class="fas fa-cogs"></i></button>-->
      </div>
    </section>
  </div>

  <ng-container *ngIf="filterOption.Section" [ngTemplateOutlet]="filter" [ngTemplateOutletContext]="{filterBadge:currentFilterModel.Filter,prefix:''}"> </ng-container>


  <div class="filter-footer">
    <div class="filter-footer__search-row">
      <button (click)="refreshFilter()" class="q-btn q-main filter-footer__main-btn">Appliquer le filtre</button>
    </div>
    <div class="filter-footer__clear-row">
      <button (click)="OpenModelSave(content)" class="q-btn filter-footer__sub-btn "><i class="far fa-save"></i> Filtres sauvegardés</button>
      <button (click)="RaZFilter()" class="q-btn filter-footer__sub-btn filter-footer__sub-btn--clear"><i class="fa fa-times"></i> Vider les filtres</button>
    </div>



  </div>
</div>



<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Gestion des modèles</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body-config">
    <div class=" modal-body-config__model-list">
      <div *ngFor="let filterModel of filterModelList" class="ellipsis" title="{{filterModel.Info_MOD}}" (click)="selectModelConfig(filterModel.Code_MOD)" [ngClass]="{'model-selected':currentFilterModelConfig.Code_MOD == filterModel.Code_MOD}">{{filterModel.Info_MOD}}</div>
      <div class="ellipsis" (click)="selectModelConfig(null)" [ngClass]="{'model-selected':!currentFilterModelConfig.Code_MOD}">Nouveau modèle</div>
    </div>
    <div class="modal-body-config__model-data">
      <input type="text" class="q-input-no-border w-100" [(ngModel)]="currentFilterModelConfig.Info_MOD" />
      <ng-container [ngTemplateOutlet]="filter" [ngTemplateOutletContext]="{filterBadge:currentFilterModelConfig.Filter,prefix:'config'}"> </ng-container>
      <div class="d-flex">
        <div class="col-8"><button class="q-btn q-main m-0 w-100" (click)="saveModelConfig()">Enregistrer</button></div>
        <div class="col-2"><button *ngIf="currentFilterModelConfig.Code_MOD" class="q-btn m-0 q-danger q-c-main w-100" (click)="deleteModelConfig()"><i class="fas fa-trash-alt"></i></button></div>
        <div class="col-2"><button *ngIf="currentFilterModelConfig.Code_MOD" class="q-btn m-0 q-secondary q-c-main w-100" (click)="addToClipboard()"><i class="far fa-copy"></i></button></div>
      </div>

    </div>
  </div>


</ng-template>

<ng-template #OperatorSelect let-filter="filter" let-filterBadge="filterBadge">
  <select *ngIf="filter.ShowOperator" class="q-main-select" [ngModel]="filterBadge | OperatorValue:filter.PropKey" (change)="ChangeOperator($event,filter,filterBadge)">
    <option [value]="Operator.Egale">=</option>
    <option [value]="Operator.Superieur">></option>
    <option [value]="Operator.Inferieur"><</option>
    <option [value]="Operator.SuperieurEgale">>=</option>
    <option [value]="Operator.InferieurEgale"><=</option>
  </select>
</ng-template>




<ng-template #filter let-filterBadge="filterBadge" let-prefix="prefix">
  <div id="filter-body">
    <ng-container *ngFor="let section of filterOption.Section; let idSection = index;">
      <section [id]="section.Titre">
        <h1>{{section.Titre}}</h1>
        <div class="section-body">
          <ng-container *ngFor="let filter of section.FilterProperty; let idFiltre = index">

            <ng-container [ngSwitch]="filter.PropType">
              <!--#region Select-->
              <ng-container *ngSwitchCase="FilterPropertyType.Select">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div>{{filter.Text}}</div>
                  <div>
                    <!--(change)="ChangeSelect($event,filter,filterBadge)"-->
                    <select class="q-main-select w-100" (change)="ChangeSelect($event,filter,filterBadge)" [ngModel]="filterBadge | SelectValue:filter.PropKey">
                      <option value="" selected>---------</option>

                      <ng-container *ngIf="filter.directData; else asyncData">
                        <option *ngFor="let selectOption of filter.PropTypeOption" [value]="selectOption.id">{{selectOption.value}}</option>
                      </ng-container>

                      <ng-template #asyncData>
                        <option *ngFor="let selectOption of filter.PropTypeOption | async" [value]="selectOption.id">{{selectOption.value}}</option>
                      </ng-template>


                    </select>
                    <ng-container [ngTemplateOutlet]="OperatorSelect" [ngTemplateOutletContext]="{filter:filter,filterBadge:filterBadge}"> </ng-container>
                  </div>
                </div>
              </ng-container>
              <!--#endregion-->
              <!--#region AvatarSearch-->
              <ng-container *ngSwitchCase="FilterPropertyType.AvatarSearch">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div>{{filter.Text}}</div>
                  <q-avatar-search [mode]="GetComponentInputValue('mode',filter,'')"
                                   [elementList]="GetComponentInputValue('elementList',filter,'')"
                                   [labelPropName]="GetComponentInputValue('labelPropName',filter,'')"
                                   [identPropName]="GetComponentInputValue('identPropName',filter,'')"
                                   [imgPropName]="GetComponentInputValue('imgPropName',filter,'')"
                                   [value]="filterBadge | AvatarValue:filter.PropKey"
                                   [multipleSelection]="GetComponentInputValue('multipleSelection',filter,false)"
                                   [nullable]="GetComponentInputValue('nullable',filter,false)"
                                   (selectedList)="ChangeAvatarSearch($event,filter,filterBadge)">
                  </q-avatar-search>
                </div>
              </ng-container>
              <!--#endregion-->
              <!--#region InputNumber-->
              <ng-container *ngSwitchCase="FilterPropertyType.InputNumber">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div>{{filter.Text}}</div>
                  <div class="filter-number">
                    <input class="q-input-no-border mr-2" type="number" [ngModel]="filterBadge | InputNumberValue:filter.PropKey" (blur)="ChangeInput($event,filter,filterBadge)" />
                    <ng-container [ngTemplateOutlet]="OperatorSelect" [ngTemplateOutletContext]="{filter:filter,filterBadge:filterBadge}"> </ng-container>
                  </div>
                </div>
              </ng-container>

              <!--#endregion-->
              <!--#region DateRange-->
              <ng-container *ngSwitchCase="FilterPropertyType.DateRange">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div>{{filter.Text}}</div>
                  <div class="dateRange">
                    <datepicker-range [DateDebut]="filterBadge | DateRangeValue:filter.PropKey:true"
                                      [DateFin]="filterBadge | DateRangeValue:filter.PropKey:false"
                                      (DateRange)="ChangeDateRange($event,filter,filterBadge)"></datepicker-range>
                  </div>
                </div>
              </ng-container>
              <!--#endregion-->
              <!--#region Check-->
              <ng-container *ngSwitchCase="FilterPropertyType.Check">
                <div class="filter-check" [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div class="q-check">
                    <input type="checkbox" [id]="prefix+'_'+filter.PropKey+'_'+idFiltre" [ngModel]="filterBadge | CheckValue:filter.PropKey" (change)="ChangeCheck($event,filter,filterBadge)" />
                    <label [for]="prefix+'_'+filter.PropKey+'_'+idFiltre">
                      <span></span>{{filter.Text}}
                    </label>
                  </div>
                </div>
              </ng-container>
              <!--#endregion-->
              <!--#region Radio-->
              <ng-container *ngSwitchCase="FilterPropertyType.Radio">
                <div class="filter-check" [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div class="q-check">
                    <input type="radio" [id]="prefix+'_'+filter.PropKey+'_'+idFiltre" [name]="filter.PropTypeOption" [checked]="filterBadge | CheckValue:filter.PropKey" (change)="ChangeCheck($event,filter,filterBadge,true)" (click)="radioCheck(filter,filterBadge)" />
                    <label [for]="prefix+'_'+filter.PropKey+'_'+idFiltre">
                      <span></span>{{filter.Text}}
                    </label>
                  </div>
                </div>
              </ng-container>
              <!--#endregion-->
              <!--#region Button-->
              <ng-container *ngSwitchCase="FilterPropertyType.Button">
                <div class="filter-btn" [ngClass]="CalcFiltrePosition(filter,idSection,idFiltre)" [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <button class="q-btn q-main" (click)="BtnClick(filter,filterBadge)" [innerHTML]="filter.Text" *ngIf="testCondition(filter.ConditionToShow,filterBadge)"></button>
                </div>
              </ng-container>
              <!--#endregion-->
              <!-- #region Tag-->
              <ng-container *ngSwitchCase="FilterPropertyType.Tag">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <q-tag [relation]="GetComponentInputValue('relation',filter,'')" (SearchTagSelect)="ChangeTag($event,filter,filterBadge)" [tagList]="filterBadge | TagValue:filter.PropKey"></q-tag>
                </div>
              </ng-container>
              <!--#endregion-->
              <!-- #region Produit Action-->
              <ng-container *ngSwitchCase="FilterPropertyType.ProduitAction">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div>{{filter.Text}}</div>
                  <q-produit-action [element]="filterBadge | ProduitAction:filter.PropKey" (selectedElement)="ChangePoduitAction($event,filter,filterBadge)"></q-produit-action>
                </div>
              </ng-container>
              <!--#endregion-->
              <!--#region Number Range-->


              <ng-container *ngSwitchCase="FilterPropertyType.NumberRange">
                <div [style.width.%]="filter.PropWidth > 0 ? filter.PropWidth : 'unset'">
                  <div>{{filter.Text}}</div>
                  <q-comp-number-range [minValue]="GetComponentInputValue('minValue',filter,'')"
                                       [maxValue]="GetComponentInputValue('maxValue',filter,'')"
                                       [lowValue]="filterBadge | NumberRangeValue:filter.PropKey:true"
                                       [highValue]="filterBadge | NumberRangeValue:filter.PropKey:false"
                                       (numberRange)="ChangeNumberRange($event,filter,filterBadge)"></q-comp-number-range>
                </div>
              </ng-container>

              <!--#endregion-->

            </ng-container>



          </ng-container>
        </div>
      </section>
    </ng-container>
  </div>

</ng-template>
